export class DtoBillingLineItem {
	// dto is used to show that the data structure is for data transfer only.
	public id?: number;
	public name: string;
	public type: number;
	public year: number;
	public measurement: number;
	public price: number;
	public subCategories: Array<any>;
	public items_source: number;

	constructor() {
		this.subCategories = [];
	}
}

export enum ModificationType {
	create,
	edit
}
